module.exports = __webpack_public_path__ + "static/media/wimq.7bb46f8a.png";